export const flashMessage = (message, flashMessageType) => {
  const event = new Event('eiffel-spa-message');
  // @ts-ignore
  event.data = {
    message,
    flashMessageType,
  };
  window.dispatchEvent(event);
};
